module.exports = __webpack_public_path__ + "img/check2-square.fb843159.svg";